import { Grid, Stack } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import TopSection from "../../../Components/Common/Top/TopSection";
import MFHistoryTracker from "./MFHistoryTracker";
import { setActiveDataElement } from "../../../redux/userSlice";

const MFHistory = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveDataElement("Bottler Market Forecast"));
  }, [dispatch]);

  return (
    <>
      <Stack>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TopSection
              labelList={[
                { title: "Home", path: "/bmf-history" },
                { title: "Dashboard" },
              ]}
              title="Market Forecast Upload History"
            />
            <div class="container">
              {/* top table */}

              <MFHistoryTracker />
            </div>
          </Grid>
        </Grid>
      </Stack>
    </>
  );
};

export default MFHistory;
